<template>
  <div>
    <Header />
    <Slider />
    <div class="my-2 services" style="direction: ltr !important;">
      <div class="container">
        <div style="color: #4d4d4d" class="fw-bold d-block text-start">
          خدمات
        </div>
        <div dir="rtl">
          <div class="row row-cols-3 text-center justify-content-center">
            <div class="col service-item">
              <router-link :to="{ name: 'newLoads' }">
                <img class="bg-white rounded shadow service-img" src="assets/svg/barlist.svg" alt="" />
              </router-link>
              <p class="mt-1">لیست بارها</p>
            </div>

            <div class="col service-item">
              <router-link :to="{ name: 'myCargos' }">
                <img class="bg-white rounded shadow service-img" src="assets/svg/barHistory.svg" alt="" />
              </router-link>
              <p class="mt-1">تاریخچه بارها</p>
            </div>

            <div class="col service-item">
              <router-link :to="{ name: 'profile' }">
                <img class="bg-white rounded shadow service-img" src="assets/svg/Profile.svg" alt="" />
              </router-link>
              <p class="mt-1">حساب کاربری</p>
            </div>
            <!-- <div class="col service-item">
              <router-link :to="{ name: 'inquiry' }">
                <img class="bg-white rounded shadow service-img" src="assets/svg/fee.svg" alt="" />
              </router-link>
              <p class="mt-1">استعلام ها</p>
            </div> -->
          </div>
        </div>
        <div class="position-absolute-bottom">
          <div dir="ltr">
            <div class="fw-bold text-start mx-2">
              خدمات پرکاربرد
            </div>
            <div class="card pt-2 m-2">
              <div class="row justify-content-center">
                <div class="col-4">
                  <div class="row gap-2 justify-content-between w-auto">
                    <div @click="searchProvince()"
                      class="col service-item gap-2 d-flex flex-column align-items-center fw-bold">
                      <img class="bg-white rounded shadow service-img" src="assets/svg/Search.svg" alt="search" />
                      <p>جستجوی استانی</p>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div @click="nearLoads()"
                    class="col service-item gap-2 d-flex flex-column align-items-center fw-bold">
                    <img class="bg-white rounded shadow service-img" src="assets/svg/Location.svg" alt="location" />
                    <p>بارهای اطراف من</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <MusicPlayer /> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Slider from '@/components/Slider.vue'
import Header from '@/components/HeaderHome.vue'
import router from '@/router'
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'home',
  components: {
    Slider,
    Header
  },
  data() {
    return {
      axiosConfig: {
        headers: {
          'Authorization': `Bearer ${window.localStorage.getItem("token")}`,
          'Accept': 'application/json'
        }
      },
    };
  },
  methods: {
    nearLoads() {
      router.push({ name: 'nearLoads' })
    },
    searchProvince() {
      router.push({ name: 'selectCities' })
    },
    tokenHandle() {
      axios.patch(`https://core.iran-tarabar.ir/api/driver/saveMyFireBaseToken`, {
        token: this.$route.query.token
      }, this.axiosConfig)
        .catch((error) => {
          if (error.response.status === 401) {
            Swal.fire({
              title: "راننده محترم!",
              text: "شماره ای که با آن وارد برنامه شده اید، توسط دستگاه دیگری مورد استفاده قرار گرفته است!",
              icon: "error",
              confirmButtonColor: "#068b80",
              confirmButtonText: "ورود مجدد!",
            }).then((result) => {
              if (result.isConfirmed) {
                localStorage.clear();
                router.push({ name: 'login' })
              }
            });

          }
        });
    }
  },
  mounted() {
    localStorage.removeItem('scrollPosition');

    // if (this.$route.query.token != undefined) {
    this.tokenHandle();
    // }

  },

}
</script>
<style scoped>
.position-absolute-bottom {
  position: absolute;
  bottom: 7rem;
  right: 0px;
  left: 0px;
}

p {
  font-size: 13px;
}

.service-item {
  font-weight: 500;
}

.service-item-container {
  height: 83px;
  width: 100px;
}

.service-img {
  width: 56px;
}

.popular-services {
  width: 328px;
  height: 128px;
}

main {
  min-height: 630px;
}
</style>